<template>
  <b-card
    v-if="tableData"
    no-body
    class="card-company-table"
  >
    <b-card-header>
      <!-- <span class="font-weight-bold city-title">Status Statistics</span> -->
      <div>
        <b-card-title class="chart-title">
          Status Statistics</b-card-title>
        <b-card-text class="font-small-2" />
      </div>
      <b-button
        v-if="showRefreshButton"
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        size="sm"
        variant="outline-primary"
        class="widgetrefresh-button d-sm-flex align-items-center justify-content-center shadow-custom"
        :style="cardBorder"
        @click="refreshWidget"
      >
        <feather-icon
          icon="RefreshCwIcon"
          class="mr-50 refresh-icon"
        />
        <span class="align-middle refresh-span" />
        <time-ago
          class="timeAgo"
          :datetime="lastUpdatedAt"
          refresh
          locale="en"
          :long="true"
          :style="{color: '#1C1F32'}"
        />
      </b-button>
    </b-card-header>
    <div class="table-wrapper">
      <b-table
        :items="tableData"
        responsive
        :fields="fields"
        class="mb-0"
        show-empty
        thead-class="table-header-custom"
      >
        <!-- statusIcon -->
        <template #cell(status_icon)="data">
          <div class="d-flex align-items-center">
            <b-avatar
              size="32"
              :variant="'light-'+data.item.status_color"
            >
              <feather-icon
                size="20"
                :icon="data.value"
              />
            </b-avatar>
          </div>
        </template>

        <template #cell(delivery_charge)="data">
          {{ __numberWithCommas(data.value, true) }}
        </template>

        <template #cell(ratio)="data">
          {{ roundToNearest(data.value) }}
        </template>

        <template #cell(order_count)="data">
          {{ (data.value).toLocaleString() }}
        </template>
      </b-table>
    </div></b-card>
</template>

<script>
import {
  BCard,
  BTable,
  BAvatar,
  BButton,
  BCardHeader,
  BCardTitle,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import { TimeAgo } from 'vue2-timeago'
import RefreshMixin from '@/@core/mixins/ui/refresh'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    TimeAgo,
    BButton,
    BCardHeader,
    BCardTitle,
  },
  mixins: [RefreshMixin],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    lastUpdatedAt: {
      type: String,
      default: null,
    },
    queue: {
      type: String,
      required: true,
    },
    showRefreshButton: {
      type: Boolean,
      default: true, // or false, depending on your default preference
    },
  },

  data() {
    return {
      avatarText,
      fields: [
        { key: 'status_icon', label: 'Status Icon' },
        { key: 'status_name', label: 'Status Name' },
        {
          key: 'order_count',
          label: 'No of Orders',
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'delivery_charge',
          label: 'Delivery Charge',
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'ratio',
          label: 'Ratio %',
          thClass: 'text-right',
          tdClass: 'text-right',
        },
      ],
    }
  },
  computed: {
    cardBorder() {
      return {
        border: '1px solid var(--primary) !important',
      }
    },
  },
  methods: {
    roundToNearest(ratio) {
      return `${Number(ratio).toFixed(2)}%`
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../@core/scss/base/bootstrap-extended/include';
@import '../../@core/scss/base/components/variables-dark';
@import '../@core/scss/vue/pages/widget-refresh.scss';

.card-company-table ::v-deep td .b-avatar.badge-light-company {
  .dark-layout & {
    background: $theme-dark-body-bg !important;
  }
}
.table-wrapper {
  padding: 0 1.5rem 1rem; /* Adjust padding as needed: Top, Left/Right, Bottom */
}
.city-title {
  font-weight: 500;
  font-size: 1.285rem;
}
.card-company-table ::v-deep .table-header-custom th {
  background-color: #ECF6FF !important; // Example blue color, change as needed
  color: #1C1F32 !important; // Example text color, change as needed
}
.refresh-icon {
  color: #1C1F32;
}
</style>
